<template>
  <section class="edit-container">
    <h2>Edit Endorsement Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>
    <div class="form-container">
      <div>
        <div class="form-item">
          <span>Contact Number</span>
          <v-input v-model="formData.contact_no"/>
        </div>
        <!--        <div class="form-item">-->
        <!--          <span>Preferred Time for Call-back</span>-->
        <!--          <v-select-->
        <!--            v-model="formData.preferred_time"-->
        <!--            :list="globalOptions.call_back_preferred_time" />-->
        <!--        </div>-->
        <h3>Endorsement Type</h3>
        <div class="form-item">
          <span>Action</span>
          <v-radio-group
            v-model="formData.action"
            :button="true"
            :list="actionOption"
            :disabled="true" />
        </div>
        <!-- <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Insurance History And Claim Record</span>
          <v-radio-group
            v-model="formData.insurance_claim_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Change Policyholder Information</span>
          <v-radio-group
            v-model="formData.change_policy_holder_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Change Driver Information</span>
          <v-radio-group
            v-model="formData.change_driver_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Change Car Detail</span>
          <v-radio-group
            v-model="formData.change_car_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Other</span>
          <v-radio-group
            v-model="formData.other_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          class="form-item"
          :class="{ 'mask': maskForm }">
          <span>Change Policy Period</span>
          <v-radio-group
            v-model="formData.change_policy_period_ind"
            :border="true"
            :list="yesNoOptions" />
        </div> -->
      </div>
      <div>
        <div class="form-item">
          <span>Message</span>
          <v-input
            v-model="formData.message"
            type="textarea"
            :rows="4" />
        </div>
        <h3>Documents</h3>
        <div class="mg-b-15">
          <v-button
            type="warning"
            @click="downloadCancelForm">Download Cancellation Form</v-button>
        </div>
        <section v-if="formData.other_file && formData.other_file.length > 0">
          <file-container
            v-for="(item, index) in formData.other_file"
            :key="index"
            :fileData="item"
            :edit="true"
            :otherData="{
              index
            }"
            @uploadSuccess="handlerUploadSuccess"
            @delete="deleteOtherFile">
            <!-- document{{ index+1 }} -->
          </file-container>
        </section>
        <v-upload
          @uploadSuccess="handlerUploadSuccess" />
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import { changeTicketCategory, editTicketEndorsement, getCancelForm } from '@/api/ticket'
import {downloadFile} from '@/utils/download'
export default {
  name: 'EditEndorsement',
  components: {
    FileContainer
  },
  mixins: [MixinOptions],
  props: {
    ticketId: [Number, String],
    changeCategoryType: {
      type: [Number, String],
      default: ''
    },
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    },
    isFina: {
      type: Boolean,
      default:false
    }
  },
  data() {
    return {
      formData: {
        // effective_date: '',
        action: '',
        insurance_claim_ind: '',
        change_policy_holder_ind: '',
        change_driver_ind: '',
        change_car_ind: '',
        other_ind: '',
        message: '',
        change_policy_period_ind: '',
        contact_no: '',
        preferred_time: '',
        other_file: []
      },
      cancelFormUrl: '',
      actionOption: [
        {
          name: 'Endorsement',
          id: 1
        },
        {
          name: 'Cancellation',
          id: 2
        }
      ],
    }
  },
  computed: {
    maskForm() {
      return this.formData.action === 2
    },
    orderId(){
      let {order_id} = this.form||{}
      return order_id
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
      }
    }
  },
  methods: {
    handlerSave() {
      // 處理 other file
      // const otherData = this.otherFileList.reduce((result, item, index) => {
      //   result[`other_file_${index+1}_path`] = item.name
      //   result[`other_file_${index+1}_path_id`] = item.id
      //   return result
      // }, {})
      if(this.changeCategoryType === '') {
        this.network().editTicketEndorsement()
      } else {
        this.network().changeTicketCategory()
      }
    },
    async downloadCancelForm() {
      if(!this.cancelFormUrl) {
        await this.network().getCancelForm()
      }
      window.open(this.cancelFormUrl, '_blank')
    },
    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    network() {
      return {
        changeTicketCategory: async () => {
          const { data } = await changeTicketCategory({
            ticket_id: this.ticketId,
            type: 3,
            customer_id: this.customerId,
            ...this.formData,
            merchant_platform:this.isFina?2:1
          })
          // 初始化表單
          this.$emit('save')
        },
        editTicketEndorsement: async () => {
          const { data } = await editTicketEndorsement({
            ticket_id: this.ticketId,
            customer_id: this.customerId,
            ...this.formData,
            merchant_platform:this.isFina?2:1
          })
          this.$emit('save')
        },
        getCancelForm: async () => {
          let res = await getCancelForm({order_id: this.orderId})
          downloadFile(res)
          // this.cancelFormUrl = data.download_url
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        display: flex;
        justify-content: space-between;
        & > div {
            width: calc(50% - 10px);
        }
    }
}
</style>
